import axios from 'axios'

import { Api } from '../../legacy/utils/api'

const deliveryApi = new Api(Api.BASE_URL.DP_C3)
const alsApiAxiosInstance = axios.create({
  baseURL: 'https://www.als.ogcio.gov.hk',
})

const apiService = {
  getALSAddress: async address => {
    const endpoint = '/lookup'
    const params = {
      q: address,
      n: 1,
    }

    try {
      const result = await alsApiAxiosInstance.get(endpoint, {
        params,
        // language options zh-Hant or en
        headers: { Accept: 'application/json', 'Accept-Language': 'en' },
      })

      return result.data
    } catch (error) {
      throw error
    }
  },

  getQuote: async orders => {
    const method = 'post'
    const endpoint = '/orders/bulk_quote'
    const body = { ...orders }

    try {
      const result = await deliveryApi.request(method, endpoint, null, body)
      return result.data
    } catch (error) {
      error.message = error.response?.data?.error?.code || error.message
      error.orderFailures = error.response?.data?.error?.order_failures || {}
      throw error
    }
  },

  placeOrders: async orders => {
    const method = 'post'
    const endpoint = '/orders/bulk'
    const body = { ...orders }

    try {
      const result = await deliveryApi.request(method, endpoint, null, body)
      return result.data
    } catch (error) {
      error.message = error.response?.data?.error?.code || error.message
      error.orderFailures = error.response?.data?.error?.order_failures || {}
      throw error
    }
  },
}

export { apiService }
